import './UploadFile.scss';
import Component from './UploadFile.js';
export { acceptsFile } from './UploadFile.js';
export { default as FileDropTarget } from './FileDropTarget.js';
export default Component;
